import IconButton from 'lib/IconButton';
import removeSvg from 'assets/icons/remove.svg';
import { CollapsibleCategoryButtonsProps } from './CollapsibleCategoryButtonProps.types';

const CollapsibleCategoryButtons: React.FC<CollapsibleCategoryButtonsProps> = ({
  onRemove,
}: CollapsibleCategoryButtonsProps) => {
  return <IconButton name="remove-icon-button" icon={removeSvg} handleOnClick={onRemove} />;
};

export default CollapsibleCategoryButtons;
